"use client";

import { useSyncExternalStore } from "react";
import { isTourOnScreen, subscribeTourVisit } from "@/utils/acknowledgements/tourVisit";

/** True while any guided tour is showing in this tab. Always false on the server. */
export function useTourOnScreen(): boolean {
  return useSyncExternalStore(subscribeTourVisit, isTourOnScreen, () => false);
}
